// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"dd12c884","787":"359ebf03"}[chunkId] + ".chunk.js";
};